import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Breadcrumbs, Typography, Box, Divider } from '@mui/material';
import { NavigateNext as NavigateNextIcon } from '@mui/icons-material';
import './Breadcrumb.css';

const Breadcrumb = ({ items = [] }) => {
  const navigate = useNavigate();

  const handleClick = (path) => {
    if (path) {
      navigate(path);
    }
  };

  return (
    <Box className="breadcrumb-container">
      <nav aria-label="breadcrumb">
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" className="breadcrumb-separator" />}
        >
          {items.map((item, index) => {
            const isLast = index === items.length - 1;
            
            if (isLast) {
              return (
                <Typography 
                  key={`${item.label}-${index}`}
                  className="breadcrumb-current"
                  aria-current="page"
                >
                  {item.label}
                </Typography>
              );
            }
            
            return (
              <button
                key={`${item.label}-${index}`}
                onClick={() => handleClick(item.path)}
                className="breadcrumb-link"
                type="button"
                aria-label={`Navigate to ${item.label}`}
              >
                {item.label}
              </button>
            );
          })}
        </Breadcrumbs>
      </nav>
      <Divider className="breadcrumb-divider" />
    </Box>
  );
};

export default Breadcrumb;